/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/subgenero";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/subgenero/subgenero",
            controller: 'SubgeneroAdminController',
            controllerForm: 'SubgeneroFormAdminController',
            translateBase: "admin.subgenero."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']

            }
        });
        // Listar
        angular.merge(state.list, {
            resolve: {

                /* @ngInject */
                tipologias: function (Tipologia) {
                    return Tipologia.findAll().$promise.then(function (data) {
                        return data.content;
                    });
                }
            }
        });


        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list);
    }
})();
